export default __webpack_public_path__ + "static/frontline-287879cc1742c3cc405988b9f56dcd17.png";